import { useEffect, useState } from "preact/hooks";
import type { DashboardViewModel } from "../app/dashboardViewModel";

/**
 * Compact one-line banner shown in Safari when the app is not running standalone. Only the installed copy is exempt
 * from Safari's seven-day storage eviction. Visibility logic and the dismissal (IndexedDB settings) live in the view
 * model; this component only detects the environment.
 */
export function isStandalone(): boolean {
  const nav = navigator as Navigator & { standalone?: boolean };
  return window.matchMedia?.("(display-mode: standalone)").matches === true || nav.standalone === true;
}

export function isSafari(): boolean {
  const ua = navigator.userAgent;
  return /Safari\//.test(ua) && !/Chrome\/|Chromium|CriOS|FxiOS|EdgiOS|Edg\/|OPR\/|Android/.test(ua);
}

export function InstallHint({ vm }: { vm: DashboardViewModel }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    void vm.installHintVisible({ standalone: isStandalone(), safari: isSafari() }).then(setShow);
  }, []);
  if (!show) return null;
  return (
    <div class="banner" role="note">
      <span class="grow">Add to Home Screen to keep your shots safe: Share {"→"} Add to Home Screen.</span>
      <button class="ghost" type="button" aria-label="Dismiss" onClick={() => { setShow(false); void vm.dismissInstallHint(); }}>{"✕"}</button>
    </div>
  );
}
